import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { LabelWrapper, Wrapper } from './styled.js';
export const TableNote = memo(function TableNote({ label, value, dataTestId }) {
    return (_jsxs(Wrapper, { "data-testid": dataTestId, children: [_jsx(LabelWrapper, { children: label }), value] }));
});
